import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { LibTableRecordFieldComponent } from 'tuain-ng-forms-lib';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';
import * as moment from 'moment';


@Component({
  selector: 'row-field',
  templateUrl: './row-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTableRecordFieldComponent extends LibTableRecordFieldComponent implements OnInit {
  icon: String;
  iconBoolean: String;
  constructor(public _iconDictionary: IconDictionaryService) {
    super();
  }

  override ngOnInit() {
    this.icon = this._iconDictionary.mapIcon(this.fieldValue);
    this.iconBoolean = this._iconDictionary.mapIcon(this.fieldValue ? 'CHECK' : 'UNCHECK');
  }

  parseMoment = date => moment.utc(date).format('YY-MM-DD HH:mm');
  parseMomentUtc = date => moment(date).format('YY-MM-DD HH:mm');
}
